const pluralize = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;

/**
 * Format landowner average response time (in hours) for display.
 * Under 1 hour → minutes
 * Up to 24 hours → hours
 * Over 24 hours → days + hours
 *
 * @param {number} hours
 * @returns {string|null}
 */
export const formatResponseTime = hours => {
  if (hours == null || !Number.isFinite(Number(hours))) {
    return null;
  }

  const numericHours = Number(hours);

  if (numericHours < 1) {
    const minutes = Math.round(numericHours * 60);
    return pluralize(minutes, 'minute', 'minutes');
  }

  const roundedHours = Math.round(numericHours);

  if (roundedHours > 24) {
    const days = Math.floor(roundedHours / 24);
    const remainingHours = roundedHours % 24;
    const daysLabel = pluralize(days, 'day', 'days');

    if (remainingHours === 0) {
      return daysLabel;
    }

    return `${daysLabel} ${pluralize(remainingHours, 'hour', 'hours')}`;
  }

  return pluralize(roundedHours, 'hour', 'hours');
};
